var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-select", {
        ref: "speciesSelect",
        attrs: {
          value: _vm.sword,
          "use-input": "",
          "fill-input": "",
          "hide-selected": "",
          "input-debounce": "0",
          label: _vm.$t("species"),
          options: _vm.options,
          loading: _vm.speciesList.length === 0,
          error: _vm.error,
          "error-message": _vm.errorMessage,
          "hide-bottom-space": ""
        },
        on: { input: _vm.selectSpecies, filter: _vm.filterSpecies },
        scopedSlots: _vm._u([
          {
            key: "no-option",
            fn: function(scope) {
              return [
                _vm.speciesList.length
                  ? _c("div", { staticClass: "q-pa-md" }, [
                      _vm._v(_vm._s(_vm.$t("noResults")))
                    ])
                  : _c(
                      "div",
                      { staticClass: "q-pa-md text-center" },
                      [
                        _c("q-spinner-cube", {
                          attrs: { color: "primary", size: "3em" }
                        })
                      ],
                      1
                    )
              ]
            }
          },
          {
            key: "option",
            fn: function(scope) {
              return [
                _c(
                  "q-item",
                  _vm._g(
                    _vm._b(
                      { key: scope.opt.uid, attrs: { clickable: "" } },
                      "q-item",
                      scope.itemProps,
                      false
                    ),
                    scope.itemEvents
                  ),
                  [
                    _vm.dense
                      ? [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(scope.opt.name) +
                              "\n\t\t\t\t"
                          )
                        ]
                      : [
                          _c("q-img", {
                            staticClass: "species-selector-image",
                            attrs: {
                              src: scope.opt.teaser,
                              alt: scope.opt.name,
                              ratio: "1",
                              basic: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("p", { staticClass: "text-h6 q-px-lg" }, [
                            _vm._v(_vm._s(scope.opt.name))
                          ])
                        ]
                  ],
                  2
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }